/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис управления обновлениями
 */

/**
 * Сервис управления обновлениями
 */
export class UpdateServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Скачать прошивку для обновления
   */
  PostUpdateDownload = (req: PostUpdateDownloadRequestDto, init?: RequestInit): Promise<PostUpdateDownloadResponseDto> => {
    return fm.request<PostUpdateDownloadRequestDto, PostUpdateDownloadResponseDto>(`${this.host}/device/api/v1/update/download`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Запустить обновление домофона
   */
  PostUpdateApply = (req?: PostUpdateApplyRequestDto, init?: RequestInit): Promise<PostUpdateApplyResponseDto> => {
    return fm.request<PostUpdateApplyRequestDto, PostUpdateApplyResponseDto>(`${this.host}/device/api/v1/update/apply`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос применения обновления
 */
export type PostUpdateApplyRequestDto = {
}
/**
 * Ответ на запрос применения обновления
 */
export type PostUpdateApplyResponseDto = {
}
/**
 * Запрос скачивания обновления
 */
export type PostUpdateDownloadRequestDto = {
  /**
   * Имя FTP папки
   */
  ftpPath: string
  /**
   * Имя файла обновления
   */
  fileName: string
  /**
   * Режим обновления
   */
  updateMode: string
}
/**
 * Ответ на запрос скачивания обновления
 */
export type PostUpdateDownloadResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostUpdateDownloadResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type PostUpdateDownloadResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type PostUpdateDownloadResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос применения обновления
   */
  "PostUpdateApplyRequest": {
    "kind": "class",
    "text": "Запрос применения обновления",
  },
  /**
   * Ответ на запрос применения обновления
   */
  "PostUpdateApplyResponse": {
    "kind": "class",
    "text": "Ответ на запрос применения обновления",
  },
  /**
   * Запрос скачивания обновления
   */
  "PostUpdateDownloadRequest": {
    "kind": "class",
    "text": "Запрос скачивания обновления",
    "fields": {
      /**
       * Имя FTP папки
       */
      "ftpPath": {
        "type": "string",
        "text": "Имя FTP папки",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Имя файла обновления
       */
      "fileName": {
        "type": "string",
        "text": "Имя файла обновления",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Режим обновления
       */
      "updateMode": {
        "type": "string",
        "text": "Режим обновления",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос скачивания обновления
   */
  "PostUpdateDownloadResponse": {
    "kind": "class",
    "text": "Ответ на запрос скачивания обновления",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostUpdateDownloadResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "PostUpdateDownloadResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
}